_getKeyValuePairFromCookieString